import type { ResourceKey } from 'i18next'
import be from './web-common-be.json'
import en from './web-common-en.json'
import ru from './web-common-ru.json'

import dBe from './newbelarus-be.json'
import dEn from './newbelarus-en.json'
import dRu from './newbelarus-ru.json'

export const belarusCommonTranslation = be as ResourceKey
export const englishCommonTranslation = en as ResourceKey
export const russianCommonTranslation = ru as ResourceKey

export const belarusNewBelarus = dBe as ResourceKey
export const englishNewBelarus = dEn as ResourceKey
export const russianNewBelarus = dRu as ResourceKey
